//* 편리정보 > 자주쓰는 장지 관리 (마이페이지에서 분리)
import { FC } from 'react';

import PreferCemeteryEditor from '../containers/PreferCemeteryEditor/PreferCemeteryEditor';
import { useTitleHook } from '../hooks/useTitleHook';

const PreferCemeteryPage: FC = () => {
  useTitleHook('자주쓰는 장지 관리');

  return (
    <div className="space-y-4 px-4 py-4 text-sm">
      <div className="space-y-3 rounded-xl px-5 py-4 theme-bg-1">
        <p className="text-xs theme-text-8">
          등록한 장지는 부고 등록·수정 화면의 장지 입력에서 바로 고를 수 있습니다.
        </p>
        <PreferCemeteryEditor />
      </div>
    </div>
  );
};

export default PreferCemeteryPage;
